interface IntercomConfig {
    app_id: string
    user_id?: string
    name?: string
    email?: string
    created_at?: number
    company?: {
        id: string
        name: string
    }
}

class IntercomService {
    private isInitialized = false

    initialize(config: IntercomConfig) {
        if (this.isInitialized) {
            console.warn('Intercom is already initialized')
            return
        }

        // Validate required fields
        if (!config.app_id) {
            console.error('Intercom: app_id is required')
            return
        }

        if (!config.email) {
            console.error('Intercom: email is required')
            return
        }

        try {
            // Use the traditional Intercom API
            if ((window as any).Intercom) {
                ;(window as any).Intercom('boot', config)
                this.isInitialized = true
            } else {
                console.error('Intercom widget not loaded')
            }
        } catch (error) {
            console.error('Failed to initialize Intercom:', error)
            this.isInitialized = false
        }
    }

    updateUser(userData: { user_id?: string; name?: string; email?: string; created_at?: number }) {
        if (!this.isInitialized) {
            console.warn('Intercom not initialized')
            return
        }

        try {
            if ((window as any).Intercom) {
                ;(window as any).Intercom('update', userData)
            }
        } catch (error) {
            console.error('Failed to update Intercom user:', error)
        }
    }

    show() {
        if (!this.isInitialized) {
            console.warn('Intercom not initialized')
            return
        }

        try {
            if ((window as any).Intercom) {
                ;(window as any).Intercom('show')
            }
        } catch (error) {
            console.error('Failed to show Intercom:', error)
        }
    }

    hide() {
        if (!this.isInitialized) {
            console.warn('Intercom not initialized')
            return
        }

        try {
            if ((window as any).Intercom) {
                ;(window as any).Intercom('hide')
            }
        } catch (error) {
            console.error('Failed to hide Intercom:', error)
        }
    }

    shutdown() {
        if (!this.isInitialized) {
            return
        }

        try {
            if ((window as any).Intercom) {
                ;(window as any).Intercom('shutdown')
            }
            this.isInitialized = false
        } catch (error) {
            console.error('Failed to shutdown Intercom:', error)
        }
    }
}

export const intercomService = new IntercomService()
